var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18652 11.7529V7.44621L7.50964 12.4221L9.62925 12.9598L6.13979 8.39131L10.9482 13.2207L14.4742 13.7846L6.94226 8.2238L16.3568 13.8501L23.3333 14L5.67385 7L23.3333 0L16.3568 0.149944L6.94227 5.7762L14.4742 0.215365L10.9482 0.77929L6.13983 5.60865L9.62925 1.0402L7.50964 1.57795L5.18652 6.5538V2.28918L3.75501 2.85206V11.19L5.18652 11.7529Z",
    fill: "#00D084"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30127 10.4809V3.56124L3.27013 3.06274V10.9796L2.30127 10.4809Z",
    fill: "#00D084"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09031 4.30465V9.7377L1.81701 10.1946V3.84749L1.09031 4.30465Z",
    fill: "#00D084"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44555e-06 8.83595L0 5.20615L0.666214 4.6629L0.666217 9.3792L5.44555e-06 8.83595Z",
    fill: "#00D084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.19814ccaab7562610acf741cf0af45e0.svg";
export { ForwardRef as ReactComponent };